import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { Card, CardContent } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import StarRating from "../../../components/StarRating";
import { useNavigate, useParams } from "react-router-dom";
import { Progress } from "../../../components/ui/progress";
import { CoursesData } from "../../../lib/languages";
import { CourseCard } from "../../../components/CourseCard";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../../lib/api";
import { toast } from "sonner";
import CardSkeleton from "../../../components/common/CardSkeleton";
import { useAPI } from "../../../context/APIContext";

export default function UserCourses() {
  const navigate = useNavigate();
  const { courseType } = useParams();

  const { language } = useLanguage();
  const t = CoursesData[language] || CoursesData["en"];

  const [sortBy, setSortBy] = useState("latest");

  // -------------Courses-------------
  const { studentCoursesItems } = useAPI();
  const { loadingStudentCourses, studentCourses } = studentCoursesItems;

  const sortedCourses = [...studentCourses].sort((a, b) => {
    if (sortBy === "latest") return b.id - a.id; // Newest courses first
    if (sortBy === "rating") return b.rating - a.rating; // Highest rated first
    if (sortBy === "price") return a.rating - b.rating; // Assuming lower rating means cheaper course
    return 0;
  });

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="flex items-center justify-between gap-2">
        <p className="font-bold text-2xl">
          {courseType === "watched"
            ? t.coursesWatched
            : courseType === "completed"
            ? t.completedCourses
            : t.currentCourses}
        </p>
        <Select onValueChange={setSortBy} defaultValue={sortBy}>
          <SelectTrigger className="w-[9rem]">
            <SelectValue placeholder={t.sortBy} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="latest">{t.latest}</SelectItem>
            <SelectItem value="rating">{t.rating}</SelectItem>
            <SelectItem value="price">{t.price}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {loadingStudentCourses ? (
        <CardSkeleton />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {sortedCourses.map((item, index) => (
            <CourseCard
              key={index}
              item={item}
              btnTitle={
                courseType === "watched"
                  ? t.registerNow
                  : courseType === "completed"
                  ? t.completed
                  : t.continueWatching
              }
              onClick={() =>
                navigate(`/course-details`, { state: { course: item } })
              }
            />
          ))}
        </div>
      )}
    </div>
  );
}
